import React from 'react';
import { ISearchResult } from '../interfaces/types';
interface SearchFilterCategoriesProps {
    results: ISearchResult[];
}

export const SearchResultsList: React.FC<SearchFilterCategoriesProps> = ({ results }) => {
    return (
        <ul className="stack">
            {results.map((result, index) => (
                <li key={index} className="search-results-item">
                    <div className={`search-results-item-inner search-results-item-inner-${result.pageTheme}`} style={{ "--search-results-item-bg": result.pageThemeColor } as React.CSSProperties}>
                        <div className="search-results-item-content">
                            <div className="search-results-item-top">
                                <h3 className="h2-style">
                                    <a href={result.pageUrl} className="search-results-item-link" dangerouslySetInnerHTML={{ __html: result.pageTitle }}></a>
                                </h3>
                                <p className="search-results-item-contentype">{result.contentType}</p>
                            </div>
                            <div className="search-results-item-info">
                                <p className="bold">{result.publishDate}</p>
                                {
                                    result.venueName !== "" && result.contentType === "Production" ?
                                        <p className="bold">
                                            {
                                                result.venueLink !== "" ?
                                                    <a href={result.venueLink}>
                                                        { result.venueName }
                                                    </a> :
                                                    <>{result.venueName}</>
                                            }
                                        </p> : null
                                }
                            </div>
                            {
                                result.description !== "" ? <div className="rich-text search-results-item-description" dangerouslySetInnerHTML={{ __html: result.description }} ></div> : null
                            }
                        </div>
                        {
                            result.image != "" ? <div className="search-results-item-image">
                                <img src={result.image} alt={''} role="presentation" />
                            </div> : null
                        }
                    </div>
                </li>
            ))}
        </ul>
    )
}